export const SITE_URL = "https://sjenickiproizvodi.rs";
export const DEFAULT_IMAGE = `${SITE_URL}/link.png`;

export function upsertMeta(attr, key, content) {
  let meta = document.querySelector(`meta[${attr}="${key}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attr, key);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}

export function upsertCanonical(href) {
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", href);
}

/** Meta tags for individual product pages (called after product loads). */
export function applyProductSeo({ title, description, path }) {
  const canonicalUrl = `${SITE_URL}${path}`;
  document.title = title;
  upsertMeta("name", "description", description);
  upsertMeta(
    "name",
    "robots",
    "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
  );
  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", canonicalUrl);
  upsertMeta("property", "og:image", DEFAULT_IMAGE);
  upsertMeta("property", "og:image:width", "1280");
  upsertMeta("property", "og:image:height", "630");
  upsertMeta("property", "og:image:alt", title);
  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", DEFAULT_IMAGE);
  upsertCanonical(canonicalUrl);
}
